import { render, staticRenderFns } from "./UserAdvanceLogs.vue?vue&type=template&id=554ac80e&"
import script from "./UserAdvanceLogs.vue?vue&type=script&lang=js&"
export * from "./UserAdvanceLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports